/**
 * Slide-over overlay controller (mirrors the React ContactPages).
 *
 * [data-overlay="inquiries|private-events"] triggers (nav sublinks, contact
 * buttons, reservation modal links) open the matching sheet over the current
 * page — no navigation (the href is a no-JS fallback to the standalone page).
 * The "switch" links inside a form slide one sheet out while the other slides
 * in. Close/Esc slides the sheet down. Opening also dismisses the nav menu and
 * reservation modal so only one layer is active.
 */
(function () {
  // Guard against double-init if the script is re-injected (e.g. `theme dev`
  // hot reload). The first run's delegated listeners already query live DOM, so
  // a second run would only add duplicate listeners.
  if (window.__overlayFormsInit) return;
  window.__overlayFormsInit = true;

  var CLOSE_MS = 1200;
  var html = document.documentElement;
  var current = null;
  var unlockTimer;

  // Query the host/sheets live every time rather than caching nodes: Shopify's
  // theme editor and `theme dev` hot reload replace the section's DOM, so cached
  // references would go stale (and class toggles would hit detached nodes).
  function host() {
    return document.querySelector('[data-overlay-host]');
  }

  function sheetOf(type) {
    var h = host();
    return h ? h.querySelector('[data-overlay-sheet="' + type + '"]') : null;
  }

  function setVisible(sheet, on) {
    if (!sheet) return;
    sheet.classList.toggle('is-visible', on);
    sheet.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  function dismissOtherLayers() {
    html.classList.remove('nav-menu-open');
    var navToggle = document.querySelector('[data-nav-toggle]');
    if (navToggle) {
      navToggle.setAttribute('aria-expanded', 'false');
      navToggle.setAttribute('aria-label', 'Open menu');
    }
    var modal = document.querySelector('[data-reservation-modal]');
    if (modal) modal.classList.remove('reservation-modal--open');
  }

  function open(type) {
    var sheet = sheetOf(type);
    if (!sheet) return;
    window.clearTimeout(unlockTimer);
    dismissOtherLayers();
    if (current && current !== type) setVisible(sheetOf(current), false);
    setVisible(sheet, true);
    current = type;
    html.style.overflow = 'hidden';
  }

  function close() {
    if (!current) return;
    setVisible(sheetOf(current), false);
    current = null;
    unlockTimer = window.setTimeout(function () {
      html.style.overflow = '';
    }, CLOSE_MS);
  }

  // Delegated on document so the triggers keep working even after the section's
  // DOM is re-rendered (Shopify theme editor / `theme dev` hot reload), which
  // would drop listeners bound directly to the nodes.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // [data-overlay] open triggers can live anywhere on the page.
    var openEl = target.closest('[data-overlay]');
    if (openEl) {
      event.preventDefault();
      open(openEl.getAttribute('data-overlay'));
      return;
    }

    // Switch + close triggers only count inside the overlay host.
    var h = host();
    var switchEl = target.closest('[data-overlay-switch]');
    if (switchEl && h && h.contains(switchEl)) {
      event.preventDefault();
      open(switchEl.getAttribute('data-overlay-switch'));
      return;
    }

    var closeEl = target.closest('[data-overlay-close]');
    if (closeEl && h && h.contains(closeEl)) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) close();
  });

  // ----- Show the confirmation after a native form submit + reload -----
  // The contact forms post natively via {% form 'contact' %} (a full reload —
  // the only path Shopify's live endpoint reliably accepts). On success Shopify
  // returns to …?contact_posted=true#<form-id>, so we reveal that form's success
  // letter and, when it lives in a sheet, reopen the sheet to show it.
  function sheetTypeOf(node) {
    var types = ['inquiries', 'private-events'];
    for (var i = 0; i < types.length; i++) {
      var sheet = sheetOf(types[i]);
      if (sheet && sheet.contains(node)) return types[i];
    }
    return null;
  }

  function revealSuccess(form) {
    var hide = form.querySelectorAll(
      '[data-form-body], [data-form-actions], [data-form-hide]'
    );
    for (var i = 0; i < hide.length; i++) hide[i].style.display = 'none';
    var ok = form.querySelector('[data-form-success]');
    if (ok) ok.hidden = false;
  }

  if (/[?&]contact_posted=true/.test(window.location.search)) {
    var postedForm = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;
    if (postedForm) {
      revealSuccess(postedForm);
      var postedType = sheetTypeOf(postedForm);
      if (postedType) open(postedType);
    }
    // Strip ?contact_posted (and the form anchor) from the URL so a refresh
    // loads clean and shows the normal form instead of re-showing the letter.
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }
})();
